import { render, staticRenderFns } from "./RetailCouponCreate.vue?vue&type=template&id=57074f82&"
import script from "./RetailCouponCreate.vue?vue&type=script&lang=js&"
export * from "./RetailCouponCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports